import React from "react";
import {
  User,
  FileText,
  IndianRupee,
  Percent,
  Star,
  Search,
  ListFilter,
} from "lucide-react";

export default function AffiliatePartnerDashboardContent({
  stats,
  formatCurrency,
  formatPercentage,
  showFilterPopup,
  setShowFilterPopup,
  filters,
  handleFilterChange,
  partners,
  resetFilters,
  searchQuery,
  setSearchQuery,
  selectAll,
  handleSelectAll,
  selectedPartners,
  handleSelectPartner,
  filteredPartners,
  loading,
  navigateToProfile,
}) {
  return (
    <div className="p-4 sm:p-6 flex-1 overflow-auto">
      {showFilterPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-[#131313] p-6 rounded-lg w-full max-w-md">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">Filter Partners</h3>
              <button
                onClick={() => setShowFilterPopup(false)}
                className="text-gray-400 hover:text-white"
              >
                ✕
              </button>
            </div>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-400 mb-2">
                  Status
                </label>
                <select
                  value={filters.status}
                  onChange={(e) => handleFilterChange("status", e.target.value)}
                  className="w-full bg-black border border-[#333333] rounded-md px-3 py-2 text-white"
                >
                  <option value="all">All Status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                  <option value="Pending">Pending</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-400 mb-2">
                  Category
                </label>
                <select
                  value={filters.category}
                  onChange={(e) =>
                    handleFilterChange("category", e.target.value)
                  }
                  className="w-full bg-black border border-[#333333] rounded-md px-3 py-2 text-white"
                >
                  <option value="all">All Categories</option>
                  {Array.from(new Set(partners.map((p) => p.category))).map(
                    (category) => (
                      <option key={category} value={category}>
                        {category}
                      </option>
                    )
                  )}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-400 mb-2">
                  Date Range
                </label>
                <select
                  value={filters.dateRange}
                  onChange={(e) =>
                    handleFilterChange("dateRange", e.target.value)
                  }
                  className="w-full bg-black border border-[#333333] rounded-md px-3 py-2 text-white"
                >
                  <option value="all">All Time</option>
                  <option value="last30days">Last 30 Days</option>
                </select>
              </div>
            </div>
            <div className="flex justify-end space-x-3 mt-6">
              <button
                onClick={resetFilters}
                className="px-4 py-2 text-gray-400 hover:text-white"
              >
                Reset
              </button>
              <button
                onClick={() => setShowFilterPopup(false)}
                className="px-4 py-2 bg-[#FFCA20] text-black rounded-md"
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Partner List */}
      <div className="mb-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-[#F3F3F3]">Partner List</h2>
        </div>
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-3 sm:gap-0">
          <div className="relative w-full sm:w-auto mb-3 sm:mb-0">
            <input
              type="text"
              placeholder="Search Partner or BranchName"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="bg-black border text-[#F3F3F3] border-[#333333] rounded-full py-2 pl-10 pr-4 w-full"
            />
            <Search className="absolute left-3 top-2.5 text-[#F3F3F3] w-4 h-4" />
          </div>
          <button
            onClick={() => setShowFilterPopup(true)}
            className="bg-gray-800 text-white px-4 py-2 rounded-md flex items-center w-full sm:w-auto justify-center sm:justify-start"
          >
            <ListFilter className="mr-2 w-4 h-4" />
            <span>Filters</span>
          </button>
        </div>
        <div className="text-sm text-[#F3F3F3] mb-4">
          Select to enable bulk options
          <span className="ml-2 text-sm text-blue-400">
            ({selectedPartners.length} selected)
          </span>
        </div>
        {/* Table */}
        <div className="  bg-[#131313] rounded-lg border border-[#333333] w-full  overflow-x-auto scrollbar-hide">
          <table className="min-w-full">
            <thead className="border-y border-[#333333]">
              <tr className="border-b border-[#333333]">
                <th className="border-b border-r border-[#333333] pb-2 pr-4">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer before:content-['✔'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                  />
                </th>
                <th className="text-[#F3F3F3] border-b border-r border-[#333333] pb-2 pr-4">
                  PARTNER DETAILS
                </th>
                <th className="text-[#F3F3F3] border-b border-r border-[#333333] pb-2 pr-4">
                  CONTACT DETAILS
                </th>
                <th className="text-[#F3F3F3] border-b border-r border-[#333333] pb-2 pr-4">
                  JOINING DATE
                </th>
                <th className="text-[#F3F3F3] border-b border-r border-[#333333] pb-2 pr-4">
                  AFFILIATE CATEGORY
                </th>
                <th className="text-[#F3F3F3] border-b border-r border-[#333333] pb-2 pr-4">
                  Branch Name
                </th>
                <th className="text-[#F3F3F3] border-b border-r border-[#333333] pb-2 pr-4">
                  APPLICATIONS
                </th>
                <th className="text-[#F3F3F3] border-b border-r border-[#333333] pb-2 pr-4">
                  COMMISSION
                </th>
                <th className="text-[#F3F3F3] border-b border-r border-[#333333] pb-2 pr-4">
                  STATUS
                </th>
                <th className="text-[#F3F3F3] border-b border-r border-[#333333] pb-2">
                  ACTIONS
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredPartners.length === 0 ? (
                <tr>
                  <td colSpan="9" className="py-4 text-center text-gray-400">
                    {loading ? "Loading..." : "No partners found"}
                  </td>
                </tr>
              ) : (
                filteredPartners.map((partner) => (
                  <tr key={partner.id} className="border-b border-[#333333]">
                    <td className="py-4 pr-4 border-r border-[#333333]">
                      <input
                        type="checkbox"
                        checked={selectedPartners.includes(partner.id)}
                        onChange={() => handleSelectPartner(partner.id)}
                        className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer before:content-['✔'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                      />
                    </td>
                    <td className="py-4 pr-4 border-r border-[#333333]">
                      <div>
                        <p>
                          {partner.name}{" "}
                          {partner.isStarPartner && (
                            <Star className="inline text-[#FFCA20] w-4 h-4" />
                          )}
                        </p>
                      </div>
                    </td>
                    <td className="py-4 pr-4 border-r border-[#333333]">
                      <p>{partner.contact}</p>
                    </td>
                    <td className="py-4 pr-4 border-r border-[#333333]">
                      <p>{partner.joiningDate}</p>
                    </td>
                    <td className="py-4 pr-4 border-r border-[#333333]">
                      <p>{partner.category}</p>
                    </td>
                    <td className="py-4 pr-4 border-r border-[#333333]">
                      <p>{partner.branchName || "-"}</p>
                    </td>
                    <td className="py-4 pr-4 border-r border-[#333333]">
                      {partner.applications !== "-" ? (
                        <div>
                          <p>{partner.applications}</p>
                          <p
                            className={`text-xs ${
                              partner.applicationSuccess === "0%"
                                ? "text-red-500"
                                : "text-green-500"
                            }`}
                          >
                            Success: {partner.applicationSuccess}{" "}
                            {partner.applicationSuccessCount}
                          </p>
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="py-4 pr-4 border-r border-[#333333]">
                      <p>{partner.commission}</p>
                    </td>
                    <td className="py-4 pr-4 border-r border-[#333333]">
                      <p
                        className={`${
                          partner.status.toLowerCase() === "active"
                            ? "bg-green-500 bg-opacity-20 text-green-500"
                            : partner.status.toLowerCase() === "pending"
                            ? "bg-orange-500 bg-opacity-20 text-orange-500"
                            : "bg-[#FFCA20] bg-opacity-20 text-[#FFCA20]"
                        } px-3 py-1 rounded-full border-none focus:outline-none`}
                      >
                        {partner.status}
                      </p>
                    </td>
                    <td className="py-4">
                      <button
                        className="text-[#FFCA20] underline"
                        onClick={() => navigateToProfile(partner.id)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
